import React, { useEffect, useState } from "react";
import "./functionpreview.scss";
import { useParams } from "react-router-dom";
import { Table, Button, Spin, Icon, Tag } from 'antd';
import { ReactComponent as LayerLeft } from "../../../assets/svg/layer-left.svg";
import { useHistory } from "react-router";
import moment from "moment";
import { FunctionCodePreview } from "./FunctionCodePreview";
import { Http } from "../../../helpers/axois";
import { useSelector } from "react-redux";
import { logger } from "../../../constant/winston";
import { decodeBase64, useToast } from "../../../helpers/commonFunction";
import {GCPENDPOINT} from "../../../constant/common";
import { AppState } from "../../../stateManager/store";
import Placeholder_Icon from "../../../assets/svg/Placeholder_Icon.svg";


const permissionColumns = [
  {
    title: 'SL No',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'PROJECT',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: 'FUNCTION',
    dataIndex: 'value',
    key: 'value',
    render: (value: any[]) => (
      <>
        {value.map(value => {
          const color = "geekblue";
          return (
            <Tag color={color} key={value}>
              {value}
            </Tag>
          );
        })}
      </>
    ),
  },
]

export const FunctionPreview = () => {
  const params: any = useParams();
  const history: any = useHistory();
  const [visible, setVisible] = useState(false);
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const [functionPreview, setFunctionPreview] = useState<any>();
  const currentUserId = useSelector((state: any) => state.user.data.user.id)
  const { ErrorToast } = useToast();
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const showModal = (): void => {
    setVisible(true)
  }
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })

  //API Integration
  useEffect(() => {
    if ((!orgPermissions?.includes("marketplace.PublishFunc") || !orgPermissions.includes('org.View')) &&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching functions")
      return
    } 
    Http.get(
      `/orgs/${orgId}/marketplaceFunctions/${params.functionId}`
    ).subscribe((res: any) => {
      if (res) {
        setFunctionPreview(res.data);
      } else {
        logger.error("error");
      }
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching functions")
    }
    });
  }, [orgId, params.functionId]);


  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  if (!functionPreview) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <Spin indicator={antIcon} style={{ color: '#15808C' }} />
      </div>)
  }
  const { author_website, context, updated_at, created_by, description, name, release_notes, source, support_email, current_version, permissions, id, mode, preview_image } = functionPreview;
  // decode context 
  const contextData = decodeBase64(context);
  const parsedContext = JSON.parse(contextData);
  const paramsList = parsedContext.params;
  const configList = parsedContext.a8config;

  const paramsData: any = [];
  Object.keys(paramsList).forEach((el: any, index: number) => {
    paramsData.push({
      id: index + 1,
      key: el,
      value: paramsList[el]
    })
  })

  const configData: any = [];
  Object.keys(configList).forEach((el: any, index: number) => {
    configData.push({
      id: index + 1,
      key: el,
      value: configList[el]
    })
  })

  const Permissions: any = []
  Object.keys(permissions).forEach((el: any, index: any) => {
    Permissions.push({
      id: index + 1,
      key: el,
      value: permissions[el]
    })
  })

  const srcCode = decodeBase64(source);
  const editAccess = currentUserId === functionPreview.created_by.id;
  return (
    <>
      <div className="wrapper">
        <div className="function-header">
          <div className="function-title">
            <LayerLeft className="function-icon" onClick={() => history.goBack()} fill={"black"} />
            <span data-test-id="" className="function-name">{name}</span>
          </div>

          <div className="function-button">
            <div className="d-flex justify-content-end pr-5">
              {editAccess &&
                <Button type="ghost" className="mr-2" onClick={() => history.push(`/marketplace/functions/edit/${id}`)} >
                  Edit Function
                </Button>
              }
              <Button onClick={showModal} type="primary" >View Source</Button>
            </div>
            {visible &&
              <FunctionCodePreview functionName={name} srcCode={srcCode} visible={visible} setVisible={setVisible} />
            }
          </div>
        </div>

          <div className="function-details">
            <div className='image-container'>
              <img
                 alt='function-icon'
                src={preview_image ? `${preview_image.startsWith("https://") ? preview_image : GCPENDPOINT+preview_image}` : Placeholder_Icon}
              />
            </div>
            <div style={{width:"92%", display: "flex", flexDirection:"column", alignItems: "flex-start", justifyContent:"center"}} >
              <p className="function-title">{name}</p>
              <p className="function-description">{description}</p>
            </div>
          </div>
        {
          mode &&
          <div className="execution">
            <p className="execution-header">ExecutionMode</p>
            <p className="execution-description">{mode}</p>
          </div>
        }
        {Permissions && Permissions.length > 0 &&
          <div className="mock">
            <span className="mocks-header">Permissions</span>
            <Table
              className="permission-table"
              columns={permissionColumns}
              dataSource={Permissions}
              pagination={false}
            />
          </div>
        }

        <div style={{ marginTop: "50px" }} className="releasenotes">
          <div className="title">
            <span style={{ fontWeight: 600 }}>Release Notes</span>
            <div className="release-description">
              {release_notes}
            </div>
          </div>

          <div className="release-date">
            <p className="title" style={{ fontWeight: 600 }}>Version:</p>
            <p>{current_version}</p>
            <p>Release Date: {moment(updated_at).format("MMM Do YYYY")}</p>
          </div>

        </div>

        <div className="footer">
          <div className="about">
            <span className="author">
              <h4>Author</h4>
              <p>{created_by.first_name} {created_by.last_name}</p>
            </span>
            <span className="website">
              <h4>website</h4>
              <p>{author_website}</p>
            </span>
            <div className="getsupport">
              <h4>Get Support</h4>
              <p>{support_email}</p>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
